// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseConditionStatus } from './ResponseConditionStatus';
import {
  ResponseConditionStatusFromJSON,
  ResponseConditionStatusFromJSONTyped,
  ResponseConditionStatusToJSON,
  ResponseConditionStatusToJSONTyped,
} from './ResponseConditionStatus';
import type { ResponseRolloutReasonType } from './ResponseRolloutReasonType';
import {
  ResponseRolloutReasonTypeFromJSON,
  ResponseRolloutReasonTypeFromJSONTyped,
  ResponseRolloutReasonTypeToJSON,
  ResponseRolloutReasonTypeToJSONTyped,
} from './ResponseRolloutReasonType';
import type { ResponseRolloutConditionType } from './ResponseRolloutConditionType';
import {
  ResponseRolloutConditionTypeFromJSON,
  ResponseRolloutConditionTypeFromJSONTyped,
  ResponseRolloutConditionTypeToJSON,
  ResponseRolloutConditionTypeToJSONTyped,
} from './ResponseRolloutConditionType';

/**
 *
 * @export
 * @interface ResponseCondition
 */
export interface ResponseCondition {
  /**
   *
   * @type {string}
   * @memberof ResponseCondition
   */
  lastTransitionTime?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseCondition
   */
  message?: string;
  /**
   *
   * @type {ResponseRolloutReasonType}
   * @memberof ResponseCondition
   */
  reason?: ResponseRolloutReasonType;
  /**
   *
   * @type {ResponseConditionStatus}
   * @memberof ResponseCondition
   */
  status?: ResponseConditionStatus;
  /**
   *
   * @type {ResponseRolloutConditionType}
   * @memberof ResponseCondition
   */
  type?: ResponseRolloutConditionType;
}

/**
 * Check if a given object implements the ResponseCondition interface.
 */
export function instanceOfResponseCondition(
  value: object,
): value is ResponseCondition {
  return true;
}

export function ResponseConditionFromJSON(json: any): ResponseCondition {
  return ResponseConditionFromJSONTyped(json, false);
}

export function ResponseConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseCondition {
  if (json == null) {
    return json;
  }
  return {
    lastTransitionTime:
      json['lastTransitionTime'] == null
        ? undefined
        : json['lastTransitionTime'],
    message: json['message'] == null ? undefined : json['message'],
    reason:
      json['reason'] == null
        ? undefined
        : ResponseRolloutReasonTypeFromJSON(json['reason']),
    status:
      json['status'] == null
        ? undefined
        : ResponseConditionStatusFromJSON(json['status']),
    type:
      json['type'] == null
        ? undefined
        : ResponseRolloutConditionTypeFromJSON(json['type']),
  };
}

export function ResponseConditionToJSON(json: any): ResponseCondition {
  return ResponseConditionToJSONTyped(json, false);
}

export function ResponseConditionToJSONTyped(
  value?: ResponseCondition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    lastTransitionTime: value['lastTransitionTime'],
    message: value['message'],
    reason: ResponseRolloutReasonTypeToJSON(value['reason']),
    status: ResponseConditionStatusToJSON(value['status']),
    type: ResponseRolloutConditionTypeToJSON(value['type']),
  };
}
